var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCartWhiteShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "qz6e67jzia",
    width: "163.6%",
    height: "165.6%",
    x: "-31.8%",
    y: "-32.8%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "499csjabgb"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#qz6e67jzia)",
    transform: "translate(-311 -29) translate(311 24)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#499csjabgb)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#252525",
    fillRule: "nonzero",
    d: "M21.95 19.488c.25 0 .464-.086.644-.258.18-.171.27-.394.27-.668 0-.265-.09-.484-.27-.656-.18-.172-.395-.258-.645-.258H9.258c-.29 0-.52-.093-.692-.28-.171-.188-.285-.434-.34-.74L8.06 15.48h13.949c.836 0 1.476-.238 1.922-.714.445-.477.73-1.125.855-1.946l.844-5.695c.016-.07.027-.148.035-.234.008-.086.012-.157.012-.211 0-.29-.1-.528-.299-.715-.2-.188-.475-.281-.826-.281H6.634l-.189-1.301c-.062-.453-.207-.797-.433-1.031C5.785 3.117 5.375 3 4.782 3H.936c-.25 0-.468.096-.656.287-.187.192-.281.42-.281.686 0 .257.094.48.281.668.188.187.406.28.656.28h3.598l1.746 11.93c.117.813.399 1.456.844 1.928.445.473 1.082.71 1.91.71H21.95zM7.79 13.64l-.889-6.117h16.664l-.738 5.11c-.047.305-.152.547-.316.726-.164.18-.395.27-.692.27l-14.029.011zm2.135 11.32c.523 0 .967-.179 1.33-.538.363-.36.545-.8.545-1.324 0-.516-.182-.955-.545-1.319-.363-.363-.807-.545-1.33-.545-.344 0-.658.082-.944.246-.285.165-.511.387-.68.668-.167.282-.251.598-.251.95 0 .523.181.965.545 1.324.363.36.806.539 1.33.539zm10.312 0c.516 0 .955-.179 1.319-.538.363-.36.545-.8.545-1.324 0-.516-.182-.955-.545-1.319-.364-.363-.803-.545-1.319-.545-.523 0-.968.182-1.336.545-.367.364-.55.803-.55 1.319 0 .523.183.965.55 1.324.368.36.813.539 1.336.539z",
    transform: "translate(0 5)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCartWhiteShadow);
export default __webpack_public_path__ + "static/media/ic_cart_white_shadow.28f950b10e3f7ee9126c1a145a747493.svg";
export { ForwardRef as ReactComponent };